// client/src/components/agent/actions/StartConversationView.jsx
import { useState, useEffect } from 'react';
import theme from '../../../theme';

export default function StartConversationView({ token, onBack }) {
  const [cost, setCost] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState('');
  const [phone, setPhone] = useState('');
  const [vars, setVars] = useState({});
  const [headerUrl, setHeaderUrl] = useState('');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');
  const [leyHorario, setLeyHorario] = useState(null);
  const c = theme.colors;
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  const inputStyle = { width: '100%', padding: '6px 8px', background: c.background, color: c.text, border: `1px solid ${c.border}`, borderRadius: 6, marginBottom: 8, boxSizing: 'border-box', fontSize: 13 };

  useEffect(() => {
    fetch('/api/agent/start/cost', { headers }).then((r) => r.json()).then(setCost).catch(() => {});
    fetch('/api/agent/templates', { headers }).then((r) => r.json()).then(setTemplates).catch(() => {});
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const tpl = templates.find((t) => String(t.id) === String(templateId));

  // Variables a llenar: usa los nombres reales que envía el backend; si una
  // plantilla vieja aún no los trae, cae al conteo numérico genérico.
  const tplVars = tpl
    ? (tpl.variables?.length
        ? tpl.variables
        : Array.from({ length: tpl.variable_count || 0 }).map((_, i) => ({ index: i + 1, name: `Variable {{${i + 1}}}` })))
    : [];

  // Vista previa del body con los valores escritos sustituidos en {{1}}..{{n}}.
  const previewText = (tpl?.body_text || '').replace(/\{\{(\d+)\}\}/g, (_, n) => {
    const val = vars[Number(n)];
    if (val) return val;
    const named = tplVars.find((v) => v.index === Number(n));
    return named ? `[${named.name}]` : `{{${n}}}`;
  });

  useEffect(() => {
    if (tpl) { setVars({}); setHeaderUrl(tpl.header_example || ''); }
  }, [templateId]); // eslint-disable-line react-hooks/exhaustive-deps

  const send = async () => {
    if (!phone.trim() || !templateId) { setMsg('Completa número y plantilla'); return; }
    if (cost && !cost.sufficient) { setMsg('Saldo insuficiente, recarga saldo'); return; }
    setSending(true); setMsg(''); setLeyHorario(null);
    try {
      const r = await fetch('/api/agent/start', {
        method: 'POST', headers,
        body: JSON.stringify({ phone, template_id: Number(templateId), variables: vars, header_url: tpl?.has_header_media ? headerUrl : null }),
      });
      const data = await r.json();
      if (r.ok) setMsg('Plantilla enviada ✓');
      else if (data.insufficientBalance) setMsg('Saldo insuficiente, recarga saldo');
      else if (data.leyHorario) setLeyHorario(data);
      else setMsg(data.message || 'Error');
    } catch { setMsg('Error de red'); }
    setSending(false);
  };

  return (
    <div style={{ padding: 12, color: c.text, overflowY: 'auto' }}>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: c.primary, cursor: 'pointer', marginBottom: 8 }}>← Atrás</button>
      <h4 style={{ margin: '4px 0 10px' }}>Iniciar conversación</h4>

      <div style={{ background: cost && !cost.sufficient ? 'rgba(248,113,113,0.12)' : c.glowSubtle, border: `1px solid ${c.border}`, borderRadius: 6, padding: 8, marginBottom: 10, fontSize: 12 }}>
        ⚠️ Este mensaje tiene un costo de ${cost ? Number(cost.cost).toLocaleString('es-CO') : '…'}.
        {cost && !cost.sufficient && <div style={{ color: c.error, marginTop: 4 }}>Saldo insuficiente, recarga saldo.</div>}
      </div>

      <input style={inputStyle} placeholder="Número de celular" value={phone} onChange={(e) => setPhone(e.target.value)} />
      <select style={inputStyle} value={templateId} onChange={(e) => setTemplateId(e.target.value)}>
        <option value="">— Plantilla —</option>
        {templates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>

      {tpl && tpl.has_header_media && (
        <input style={inputStyle} placeholder="URL del header" value={headerUrl} onChange={(e) => setHeaderUrl(e.target.value)} />
      )}

      {/* Lista de variables a llenar, etiquetadas con su nombre real ({{nombre}}). */}
      {tplVars.map((v) => (
        <div key={v.index} style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 12, color: c.textMuted, marginBottom: 3 }}>{v.name}</label>
          <input style={{ ...inputStyle, marginBottom: 0 }} placeholder={`Valor para ${v.name}`} value={vars[v.index] || ''}
            onChange={(e) => setVars((p) => ({ ...p, [v.index]: e.target.value }))} />
        </div>
      ))}

      {/* Vista previa: el texto de la plantilla con los valores escritos. */}
      {tpl && tpl.body_text && (
        <div style={{ background: c.glowSubtle, border: `1px solid ${c.border}`, borderRadius: 6, padding: 8, marginBottom: 8, fontSize: 12, whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
          <div style={{ color: c.textMuted, fontSize: 11, marginBottom: 4 }}>Vista previa</div>
          {previewText}
        </div>
      )}

      <button onClick={send} disabled={sending || (cost && !cost.sufficient)} style={{ width: '100%', background: c.primary, color: '#001018', border: 'none', borderRadius: 6, padding: '8px', cursor: 'pointer', opacity: (sending || (cost && !cost.sufficient)) ? 0.6 : 1 }}>
        {sending ? 'Enviando…' : 'Enviar'}
      </button>
      {leyHorario && (
        <div style={{ marginTop: 10, background: 'rgba(250,204,21,0.12)', border: '1px solid #facc15', borderRadius: 6, padding: 10, fontSize: 12, lineHeight: 1.5 }}>
          <div style={{ color: '#facc15', fontWeight: 700, marginBottom: 4 }}>🕒 Horario no permitido</div>
          <div style={{ color: c.text, marginBottom: 6 }}>
            Según la Ley 2300 de 2023 ("Dejen de Fregar") no se pueden enviar mensajes comerciales en este horario. La plataforma funciona correctamente; el envío se bloqueó por la ley.
          </div>
          <div style={{ color: c.textMuted, fontWeight: 700, marginBottom: 2 }}>Horarios permitidos:</div>
          {(leyHorario.horarios || []).map((h, i) => (
            <div key={i} style={{ color: c.text }}>• {h}</div>
          ))}
        </div>
      )}
      {msg && <div style={{ marginTop: 8, fontSize: 13, color: msg.includes('✓') ? c.success : c.error }}>{msg}</div>}
    </div>
  );
}
